import { getNewLink as makeUrl } from 'util/workbook-util';
import Config from 'config';

export const DEVICE_COMPATIBILITY = 768;

export const getClickAwayUrl = ({ user, currentWorkbook = null }: any) => {
  const [clickAway] = currentWorkbook
    ? getClickAwayByProductCurriculumId(user.clickAways, currentWorkbook)
    : user.clickAways;

  return makeUrl(
    clickAway?.productCode ?? currentWorkbook?.bookCode,
    Config.defaultEdition,
    'clickAways'
  );
};

export function getBookCodeLastProductUsed(userSettings, books): string | null {
  const mostRecentProductCurriculum = userSettings?.productAccess?.[0]?.productCurriculum;
  if (!mostRecentProductCurriculum) return null;
  const mostRecentBook = books?.find(book =>
    book.products.find(p => +p.productCurriculumId === +mostRecentProductCurriculum)
  );
  return mostRecentBook ?? null;
}

const getClickAwayByProductCurriculumId = (clickAways, currentWorkbook) => {
  return clickAways?.filter(
    x => x.productCurriculumId === currentWorkbook?.products[0].productCurriculumId
  );
};

export const getLastProductUrl = ({ user, books }) => {
  const activeLicensesProdCurriculumIds = user.licenses
    .filter(l => !l.expired)
    .map(x => x.productCurriculumId);

  const foundBook = books.find(workbook =>
    workbook?.products?.find(p => activeLicensesProdCurriculumIds?.includes(p.productCurriculumId))
  );

  const lastBookBookCode = getBookCodeLastProductUsed(user.settings, books);
  const lastBookUsed =
    lastBookBookCode && books.find(({ bookCode }) => bookCode === lastBookBookCode);

  const isLastBookLicenseExpired = activeLicensesProdCurriculumIds.includes(
    lastBookUsed?.products?.[0]?.productCurriculumId
  );

  const bookToUse = isLastBookLicenseExpired ? lastBookUsed : foundBook;

  if (!bookToUse) return null;

  return makeUrl(bookToUse.bookCode, bookToUse.edition, 'home');
};

export const clickAwayOnlyUser = ({ clickAways, licenses }) =>
  clickAways?.length && !licenses?.length;

export const getRedirectPath = ({ user, books, location, currentWorkbook }) => {
  const isDeviceCompatible = window.innerWidth >= DEVICE_COMPATIBILITY;
  if (!isDeviceCompatible) {
    return '/device';
  }
  if (clickAwayOnlyUser(user)) return getClickAwayUrl({ user, currentWorkbook });
  if (location.pathname === '/') return getLastProductUrl({ books, user });

  return '/home';
};
